fragment PeepRelatedLeadCardFragment on Lead {
    id
    htmlUrl
    htmlUrlPath
    name
    value {
        formatted
        formattedValue {
            formatted
            prefix
            suffix
            value
        }
    }
    priority
    overdueTime
    number
    status
    avatarUrl
    contacts {
        primaryEdge {
            node {
                id
                type
                htmlUrl
                htmlUrlPath
                name
            }
        }
    }
    accounts {
        primaryEdge {
            node {
                id
                type
                htmlUrl
                htmlUrlPath
                name
            }
        }
    }
    assignee {
        id
        type
        name
    }
}
